import { Button as NovaButton } from '@fme-nova/components'
import { ButtonProps, default as MuiButton } from '@mui/material/Button'

import { createComponentWrapperWithRef } from '../../theme'

export type ButtonBaseProps = ButtonProps

export const ButtonBase = createComponentWrapperWithRef<ButtonProps>(
  {
    mui: MuiButton,
    nova: NovaButton,
  },
  'ButtonBase',
)
